import React, { useState, useEffect } from "react";
import {
    Form,
    Col,
    Row,
    Button,
    Select,
    Collapse,
    DatePicker,
    notification
} from "antd";
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import RequestHandler from "util/RequestHandler";
import { odata } from "./Helper";
import moment from "moment";
const FirmTransactionTableFilter = (props) => {
    const [form] = Form.useForm();
    const [firmSelect, setFirmSelect] = useState({
        data: [],
        loading: false,
    });
    useEffect(() => {
        if (props.data) {
            form.setFieldsValue(props.data);
        }
    }, [props.data]);
    useEffect(() => {
        if (props.data) {
            if (props.data.dateMin && props.data.dateMax) {
                props.data.dateRange = [
                    moment(props.data.dateMin),
                    moment(props.data.dateMax),
                ];
            }
            form.setFieldsValue(props.data);
        }
    }, [props.data]);
    const onFirmSeach = (value) => {
        if (value.length >= 2) {
            setFirmSelect({ data: [], loading: true });
            RequestHandler.get(
                `/Firm?$select=id,firmBranchNumber,name&$filter=${odata.contains(
                    "name",
                    value
                )} or ${odata.contains("firmBranchNumber", value)}`
            ).then((res) => {
                setFirmSelect({ data: res.value, loading: false });
            });
        } else {
            setFirmSelect({ data: [], loading: false });
        }
    };
    const onFinish = (values) => {
        {
            let result = {};
            if (values.firmBranchNumber)
                result = { firmBranchNumber: values.firmBranchNumber }
            else {
                notification.error({
                    message: "Lütfen cari seçimi yapınız.",
                    duration: 3,
                });
                return;
            }
            if (values.dateRange) {
                const [startDate, endDate] = values.dateRange;
                result = { ...result, startDate: startDate, endDate: endDate }
            }

            if (props.onFinishFilter) props.onFinishFilter(result);
        }
    };
    const clearFilter = () => {
        form.resetFields();
        if (props.onClearFilter) {
            props.onClearFilter();
        }
    };
    return (
        <Row id="filterArea" style={{ ...props.style }}>
            <Col span={24}>
                <Collapse>
                    <Collapse.Panel header={
                        <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                            <span>Filtreleme için tıklayınız.</span>
                            <span>Lütfen önce Cari seçimi yapınız</span>
                        </div>
                    }>
                        <Form
                            name="filter"
                            form={form}
                            initialValues={{
                                remember: true,
                            }}
                            layout="vertical"
                            onFinish={onFinish}
                        >
                            <Row style={{ flexDirection: "row" }}>
                                <Col xs={24} md={12} lg={6}>
                                <Form.Item name="firmBranchNumber" label={`Cari :`} >
                                        <Select
                                            allowClear
                                            showSearch
                                            style={{ width: "100%" }}
                                            dropdownStyle={{ minWidth: "50%" }}
                                            placeholder="En az 2 harf giriniz.."
                                            onSearch={onFirmSeach}
                                            filterOption={(input, option) =>
                                                option.children
                                                    .toLocaleLowerCase("tr-TR")
                                                    .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0 ||
                                                option.code
                                                    .toLocaleLowerCase("tr-TR")
                                                    .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                                            }
                                            loading={firmSelect.loading}
                                        >
                                            {firmSelect.data.map((item) => (
                                                <Select.Option
                                                key={item.firmBranchNumber}
                                                value={item.firmBranchNumber}
                                                    code={item.firmBranchNumber}
                                                >
                                                    {`${item.name} ${(item.firmBranchNumber ? `(${item.firmBranchNumber})` : '')}`}
                                                </Select.Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col xs={24} md={12} lg={6}>
                                    <Form.Item name="dateRange" label="Tarih :">
                                        <DatePicker.RangePicker
                                            format="DD.MM.YYYY"
                                            style={{ width: "100%" }}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row style={{ flexDirection: "row" }}>
                                <Col span={24} style={{ textAlign: "right" }}>
                                    <Button
                                        danger
                                        size="small"
                                        icon={<CloseOutlined />}
                                        onClick={() => clearFilter()}
                                    >
                                        Sıfırla
                                    </Button>
                                    <Button
                                        type="primary"
                                        size="small"
                                        icon={<SearchOutlined />}
                                        style={{ color: "#40a9ff", borderColor: "#40a9ff" }}
                                        htmlType="submit"
                                    >
                                        Filtrele
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                    </Collapse.Panel>
                </Collapse>
            </Col>
        </Row>);
};
export default FirmTransactionTableFilter;